// Common password list (you might want to expand this)
const commonPasswords = [
    'password',
    '123456',
    'qwerty',
    'admin',
    // Add more common passwords as needed
  ];
  
  export const sanitizeInput = (input: string): string => {
    // Remove any potentially dangerous characters
    return input.trim()
      .replace(/[<>]/g, '') // Basic XSS protection
      .replace(/[;{}()]/g, ''); // Basic injection protection
  };
  
  export const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  
  export const isCommonPassword = (password: string): boolean => {
    return commonPasswords.includes(password.toLowerCase());
  };